
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"10","height":"5"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"10","height":"5","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAFCAYAAAB8ZH1oAAAAPElEQVQYV2O0sLBo+PfvXz0DHsDExNTICJLHpxik6MSJEw1ghbgUwxSB5OEK0RUjK8JQCFMMokHWITsbAK//IS7o+E4nAAAAAElFTkSuQmCC"}})])
          )
        }
      }
    